import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Meter, MetersStore, Reading } from "../types/Store/MetersStore.types";
import apiMetersClient from "../api/api.meters";
import { useAuthStore } from "./auth.store";
import { enqueueSnackbar } from "notistack";

export const useMetersStore = create<MetersStore>()(
    persist(
        (set, get) => ({
            meters: [],
            readings: [],

            getReadings: async (limit) => {
                const meters = get().meters.filter((n) => n.is_active !== false);

                const requests = meters.map((n) =>
                    apiMetersClient.get(
                        "/api/v1/meter/meters/readings?meter_id=" +
                            n.id +
                            (limit ? "&limit=" + limit : "")
                    )
                );

                try {
                    const responses = await Promise.all(requests);

                    const newReadings: Array<Reading> = responses
                        .map((response) => {
                            const { data } = response;
                            console.log("data from readings api", data);
                            return data.readings && data.meter && data.meter.is_active !== false ? data : null;
                        })
                        .filter(Boolean) as Array<Reading>;

                    console.log("after api readings", newReadings);
                    set({ readings: newReadings });
                } catch (error) {
                    console.error("Error loading readings:", error);
                }
            },

            getReadingOffset: async (meter_id, offset, order = "DESC") => {
                const { data } = await apiMetersClient.get(
                    "/api/v1/meter/meters/readings?meter_id=" +
                        meter_id +
                        "&offset=" +
                        offset + "&sort_order=" + order
                );
                return data;
            },

            getMeters: async () => {
                const local = useAuthStore.getState();
                if (local) {
                    if (local.activeAccount) {
                        try {
                            const { data } = await apiMetersClient.get(
                                "/api/v1/meter/meters?personal_account_id=" +
                                    local.activeAccount +
                                    "&is_active=true"
                            );
                            const activeMeters = Array.isArray(data)
                                ? data.filter((m: Meter) => m.is_active !== false)
                                : [];
                            set({ meters: activeMeters });
                        } catch (error) {
                            local.logout();
                        }
                    } else {
                        local.logout();
                    }
                }
            },
            sendMeters: async (meters) => {
                let successedSendedMeters = 0;
                for (let i = 0; i < meters.length; i++) {
                    const { meter_id, value, file } = meters[i];
                    console.log(meters[i]);
                    if (!file) {
                        const { data, status } = await apiMetersClient.post(
                            "/api/v1/meter/meters/readings/transmit/json",
                            {
                                meter_id,
                                value,
                            }
                        );
                        console.log("Status without file", status);
                        if (status == 200 || status == 201)
                            successedSendedMeters++;
                    } else {
                        const formData = new FormData();
                        formData.append("file", file);
                        const { data, status } = await apiMetersClient.post(
                            `/api/v1/meter/meters/readings/transmit/form?meter_id=${meter_id}&value=${value}`,
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                                onUploadProgress: (e) => {
                                    if (e.total) {
                                        const percent = Math.round(
                                            (e.loaded * 100) / e.total
                                        );
                                        console.log(`Загружено: ${percent}%`);
                                    }
                                },
                            }
                        );

                        console.log("✅ Успех:", data);
                        if (status == 200) successedSendedMeters++;
                    }
                }

                return successedSendedMeters == meters.length;
            },
        }),
        {
            name: "meters-store", // ключ в localStorage
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                meters: state.meters,
                readings: state.readings,
            }),
        }
    )
);
